import React from "react";
import styles from './WeekdayToggle.module.scss';
import { WeekDay, weekDaysDict } from "./weekdays";

interface WeekdayToggleProps {
  dayName: WeekDay;
  isActive: boolean;
  onClick: () => void;
}

const WeekdayToggle: React.FC<WeekdayToggleProps> = ({
  dayName,
  isActive,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={`${styles.toggleContainer} ${isActive ? styles.active : ""}`}
    >
      <span>{weekDaysDict[dayName].toUpperCase()}</span>
    </div>
  );
};

export default WeekdayToggle;
